import { render, staticRenderFns } from "./UrgentenNew.vue?vue&type=template&id=9fd65816&scoped=true&"
import script from "./UrgentenNew.vue?vue&type=script&lang=js&"
export * from "./UrgentenNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fd65816",
  null
  
)

export default component.exports